import UserAPI from "@api/User.api";
import clientBG from "@assets/clientDashboardImage.png";
import EPublicRoutes from "@core-types/routes.enum";
import { useAppNavigate } from "@hooks/language/useAppNavigate";
import useUserStore from "@store/user.store";
import dayjs from "dayjs";
import { useEffect } from "react";
import { Outlet } from "react-router";
import SideBar from "./SideBar";

const UserLoginLayout: React.FC = () => {
  const { isLogin, setAffiliationInformation } = useUserStore();
  const { navigate } = useAppNavigate();

  useEffect(() => {
    if (isLogin) {
      UserAPI.getMeInformation().then((res) =>
        setAffiliationInformation({
          ...res,
          lastUpdatedAt: dayjs().toISOString(),
        }),
      );
    }
  }, [isLogin, setAffiliationInformation]);

  useEffect(() => {
    if (!isLogin) navigate(EPublicRoutes.HOME);
  }, [navigate, isLogin]);

  return (
    <div className="flex items-stretch overflow-hidden">
      <SideBar />
      <div className="relative mb-20 w-full overflow-hidden md:mb-40">
        <div
          className="absolute z-0 h-[50vh] w-full bg-cover bg-default-gradient-image-[var(--image-url)] bg-top bg-no-repeat blur-sm"
          style={
            {
              "--image-url": `url(${clientBG})`,
            } as React.CSSProperties
          }
        />
        <div className="relative z-10 max-w-[1600px] px-2 pt-12 xl:px-12">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default UserLoginLayout;
